import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CONSTANTS } from 'src/app/constants/users.constants';
import { TRANSFIYA_TRANSFER_PARAMS } from 'src/app/core/constants/General-constants';
import { Transaction } from 'src/app/models/transaction';
import { PrintServicesService } from 'src/app/services/print-services.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import moment from 'moment';
@Component({
  selector: 'app-transfiya-voucher',
  templateUrl: './transfiya-voucher.component.html',
  styleUrls: ['./transfiya-voucher.component.scss']
})
export class TransfiyaVoucherComponent implements OnInit {

  transaction: Transaction;
  transferId = '';
  currentDate = moment().format('DD/MM/YYYY');

  static loadStyle() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  constructor(
    private readonly printServicesService: PrintServicesService,
    private readonly tokenService: TokenServiceService,
    private readonly activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.transaction = this.tokenService.getAndDecodeToken();

    this.activatedRoute.queryParams.subscribe(params => { this.transferId = params[TRANSFIYA_TRANSFER_PARAMS.TRANSFER_ID] ?? '' });

    TransfiyaVoucherComponent.loadStyle();
  }

  /**
   * @description Function to print the payment receipt
  */
  printPaymentReceipt() {
    this.printServicesService.downloadImage(document.getElementById('ticketDiv'), CONSTANTS.PAYMENT_RECEIPT_TITLE);
  }
}
